<template>
  <section>
    <b-form>
      <scroll-container
        class="pt-2 mt-n30px"
        :height-offset="campaignModel.isEdit ? '55px' : heightOffset"
      >
        <b-container class="container-small">
          <b-card class="mb-1">
            <b-form-group
              class="mb-3"
              :label="$tk('ClientPortal.Form.NameOfCampaign') + ' *'"
              label-for="Name"
              :invalid-feedback="errors['Name']"
              :state="errors['Name'] == null ? null : false"
            >
              <b-form-input
                id="Name"
                v-model="campaignModel.name"
                :placeholder="$tk('ClientPortal.Form.NameOfCampaignPlaceholder')"
                :state="errors['Name'] == null ? null : false"
              />
            </b-form-group>
            <b-card-title class="mb-50">
              {{ $tk('ClientPortal.Form.ScheduleAndBudget') }}
            </b-card-title>
            <b-card-text class="text-secondary mb-2">
              {{ $tk('ClientPortal.Form.ScheduleAndBudget.Info') }}
            </b-card-text>

            <b-card-text class="mb-50">
              {{ $tk('ClientPortal.Form.Spending') }}
              <GjIcon
                v-b-tooltip.hover="$tk('ClientPortal.Form.SpendingTooltip')"
                name="Info"
              />
            </b-card-text>
            <hr class="mt-50 mb-1">
            <b-form-group class="mb-0">
              <b-form-radio
                v-model.number="campaignModel.spendingType"
                class="mb-1"
                value="1"
              >
                <b-card-text class="mb-50">
                  {{ $tk('ClientPortal.Form.Spending.Standard') }}
                </b-card-text>
                <b-card-text class="text-secondary">
                  {{ $tk('ClientPortal.Form.Spending.Standard.Info') }}
                </b-card-text>
              </b-form-radio>
              <b-form-radio
                v-model.number="campaignModel.spendingType"
                value="2"
              >
                <b-card-text class="mb-50">
                  {{ $tk('ClientPortal.Form.Spending.Accelerated') }}
                </b-card-text>
                <b-card-text class="text-secondary">
                  {{ $tk('ClientPortal.Form.Spending.Accelerated.Info') }}
                </b-card-text>
              </b-form-radio>
            </b-form-group>
          </b-card>
          <b-card class="mb-1">
            <b-card-title class="mb-50">
              {{ $tk('ClientPortal.Form.StartDate') }}
              <GjIcon
                v-b-tooltip.hover="$tk('ClientPortal.Form.StartDateTooltip')"
                name="Info"
              />
            </b-card-title>
            <hr class="mt-50 mb-1">
            <b-row class="mb-50">
              <b-col sm="6">
                <b-form-group
                  :label="$tk('ClientPortal.Form.StartDate')"
                  label-for="input-start-date"
                >
                  <vuejs-datepicker
                    id="input-start-date"
                    v-model="campaignModel.startDate"
                    bootstrap-styling
                    :utc="false"
                    :format="customFormatter"
                  />
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group
                  :label="$tk('ClientPortal.Form.StartTime')"
                  label-for="input-start-time"
                >
                  <vue-timepicker
                    id="input-start-time"
                    v-model="campaignModel.startHour"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="8">
                <b-card-title class="mb-50">
                  {{ $tk('ClientPortal.Form.EndDate') }}
                  <GjIcon
                    v-b-tooltip.hover="$tk('ClientPortal.Form.EndDateTooltip')"
                    name="Info"
                  />
                </b-card-title>
              </b-col>
              <b-col
                sm="4"
                class="text-right"
              >
                <input
                  v-model="hasEndDateString"
                  type="hidden"
                  name="HasEndDate"
                >
                <b-form-checkbox
                  v-model="campaignModel.hasEndDate"
                  class="d-block"
                  checked="false"
                  name="check-button"
                  switch
                />
              </b-col>
            </b-row>
            <hr class="mt-50 mb-1">
            <b-row>
              <b-col sm="6">
                <b-form-group
                  class="mb-0"
                  :label="$tk('ClientPortal.Form.EndDate')"
                  label-for="input-end-date"
                >
                  <vuejs-datepicker
                    id="input-end-date"
                    v-model="campaignModel.endDate"
                    bootstrap-styling
                    :disabled="!campaignModel.hasEndDate"
                    :utc="false"
                    :format="customFormatter"
                  />
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group
                  class="mb-0"
                  :label="$tk('ClientPortal.Form.EndTime')"
                  label-for="input-end-time"
                >
                  <vue-timepicker
                    id="input-end-time"
                    v-model="campaignModel.endHour"
                    :disabled="!campaignModel.hasEndDate"
                  />
                </b-form-group>
              </b-col>
              <b-col sm="12">
                <span
                  v-if="errors['EndDate']"
                  class="field-validation-valid text-danger small"
                >
                  {{ errors['EndDate'] }}
                </span>
              </b-col>
            </b-row>
          </b-card>
          <b-card>
            <b-row>
              <b-col sm="8">
                <b-card-title class="mb-50">
                  Target
                  <GjIcon
                    v-b-tooltip.hover="Target"
                    name="Info"
                  />
                </b-card-title>
              </b-col>
              <b-col
                sm="4"
                class="text-right"
              >
                <input
                  v-model="hasEndDateString"
                  type="hidden"
                  name="HasEndDate"
                >
                <b-form-checkbox
                  v-model="campaignModel.hasTargetGoal"
                  class="d-block"
                  checked="false"
                  name="check-button"
                  switch
                />
              </b-col>
            </b-row>
            <hr class="mt-50 mb-1">
            <b-row class="mb-1">
              <b-col sm="6">
                <b-form-group
                  class="mb-1"
                  label="Target goal *"
                  label-for="Target Goal"
                  :invalid-feedback="errors['TargetGoal']"
                  :state="errors['TargetGoal'] == null ? null : false"
                >
                  <b-form-input
                    v-model.number="campaignModel.targetGoal"
                    :disabled="!campaignModel.hasTargetGoal"
                    type="number"
                    min="0"
                    class="mt-50"
                  />
                </b-form-group>
              </b-col>
              <b-col sm="6">
                <b-form-group
                  class="mb-1"
                  label="Target type *"
                  label-for="Target Type"
                  :invalid-feedback="errors['TargetType']"
                  :state="errors['TargetType'] == null ? null : false"
                >
                  <b-form-select
                    v-model="campaignModel.targetType"
                    :options="targetTypeOptions"
                    :disabled="!campaignModel.hasTargetGoal"
                    size="sm"
                    class="mt-50"
                  />
                </b-form-group>

              </b-col>
              <b-col sm="12">
                <span
                  v-if="errors['GoalType']"
                  class="field-validation-valid text-danger small mt-2"
                >
                  {{ errors['GoalType'] }}
                </span>
              </b-col>
            </b-row>
          </b-card>
          <b-card>
            <b-card-title class="mb-50">
              {{ $tk('ClientPortal.Form.Budget') }}
              <GjIcon
                v-b-tooltip="$tk('ClientPortal.Form.BudgetTooltip')"
                name="Info"
              />
            </b-card-title>
            <hr class="mt-50 mb-1">
            <b-row class="mb-1">
              <b-col sm="3">
                <b-form-checkbox
                  v-model="campaignModel.totalBudgetSelected"
                  class="mt-50"
                >
                  {{ $tk('ClientPortal.Form.Budget.AllTime') }}
                </b-form-checkbox>
              </b-col>
              <b-col sm="4">
                <b-input-group class="input-group-merge">
                  <b-form-input
                    v-model.number="campaignModel.totalBudget"
                    type="number"
                    min="0"
                    :disabled="!campaignModel.totalBudgetSelected"
                    autocomplete="off"
                    @keyup="totalBudgetChanged"
                  />
                  <b-input-group-append is-text>
                    {{ $currencySymbol }}
                  </b-input-group-append>
                </b-input-group>
              </b-col>
              <b-col sm="12">
                <span
                  v-if="errors['TotalBudget']"
                  class="field-validation-valid text-danger small mt-2"
                >
                  {{ errors['TotalBudget'] }}
                </span>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="3">
                <b-form-checkbox
                  v-model="campaignModel.dailyBudgetSelected"
                  class="mt-50"
                  @change="dailyBudgetChanged"
                >
                  {{ $tk('ClientPortal.Form.Budget.Daily') }}
                </b-form-checkbox>
              </b-col>
              <b-col sm="4">
                <b-input-group class="input-group-merge">
                  <b-form-input
                    v-model.number="campaignModel.dailyBudget"
                    type="number"
                    :disabled="!campaignModel.dailyBudgetSelected"
                    min="0"
                    autocomplete="off"
                    @keyup="dailyBudgetChanged"
                  />
                  <b-input-group-append is-text>
                    {{ $currencySymbol }}
                  </b-input-group-append>
                </b-input-group>
              </b-col>
              <b-col sm="12">
                <span
                  v-if="errors['DailyBudget']"
                  class="field-validation-valid text-danger small mt-2"
                >
                  {{ errors['DailyBudget'] }}
                </span>
              </b-col>
            </b-row>
          </b-card>
        </b-container>
      </scroll-container>
      <div class="border-top text-right py-1">
        <div class="container-small mx-auto">
          <b-button
            v-if="campaignModel.isEdit && entity"
            class="bg-white"
            variant="outline-dark"
            size="sm"
            :disabled="saving"
            @click="closeEditModal"
          >
            {{ $tk('ClientPortal.Form.Actions.Cancel') }}
          </b-button>
          <b-button
            v-else-if="campaignModel.isEdit && !entity"
            class="bg-white"
            variant="outline-dark"
            size="sm"
            :disabled="saving"
            @click="cancelCampaign"
          >
            {{ $tk('ClientPortal.Form.Actions.Cancel') }}
          </b-button>
          <b-button
            v-else
            :disabled="saving"
            class="bg-white"
            size="sm"
            variant="outline-dark"
            @click="cancelCampaign"
          >
            {{ $tk('ClientPortal.Form.Actions.Cancel') }}
          </b-button>
          <b-button
            class="ml-50"
            size="sm"
            variant="primary"
            :disabled="saving || !isFormComplete"
            @click.prevent="saveCampaign"
          >
            {{ campaignModel.isEdit ? $tk('ClientPortal.Form.Actions.Save') : $tk('ClientPortal.Form.Actions.CreateCampaign') }}
          </b-button>
        </div>
      </div>
    </b-form>
    <!-- Modal when you have data written in Campaign page and you want to navigate -->
    <b-modal
      id="navigation-modal"
      ref="navigation-modal"
      centered
      :title="`Are you sure you want to navigate away?`"
    >
      <p>{{ modalMessage }}</p>
      <template #modal-footer="{ cancel }">
        <b-button
          variant="outline-secondary"
          @click="cancel()"
        >
          No
        </b-button>
        <b-button
          variant="danger"
          @click="confirm"
        >
          Yes
        </b-button>
      </template>
    </b-modal>
  </section>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import moment from 'moment'
import notification from '@/mixins/toastification'
import sweetAlert from '@/mixins/sweetAlert'
import VueTimepicker from 'vue2-timepicker'
import vuejsDatepicker from 'vuejs-datepicker'
import ScrollContainer from '@/components/ScrollContainer.vue'
import CampaignService from '@/api/client/campaigns.service'
import scrollToError from '@/mixins/scrollToError'
// import NavigationModal from '@/views/client/ads-manager/components/NavigationModal.vue'

const dailyBudgetType = 1
const totalBudgetType = 2
export default {
  inject: ['closeEditModal'],
  components: {
    GjIcon,
    vuejsDatepicker,
    VueTimepicker,
    ScrollContainer,
    // NavigationModal,
  },
  mixins: [notification, sweetAlert],
  props: {
    // eslint-disable-next-line vue/require-default-prop
    id: Number,
    heightOffset: {
      type: String,
      default: '125px',
    },
    entity: Object,
  },
  data() {
    return {
      campaignModel: {},
      errors: [],
      saving: false,
      showCancelButton: false,
      loading: true,
      targetTypeOptions: [
        { value: null, text: 'Please select an option' },
        { value: '1', text: 'Impressions' },
        { value: '2', text: 'Viewable impressions' },
        { value: '3', text: 'Clicks' },
        { value: '4', text: 'Actions' },
      ],
      modalMessage: 'Are you sure you want to navigate away? Your changes will be lost.',
    }
  },
  computed: {
    hasEndDateString() {
      return this.campaignModel.hasEndDate ? 'true' : 'false'
    },
    isFormComplete() {
      const {
        name, spendingType, dailyBudgetSelected, totalBudgetSelected,
      } = this.campaignModel

      return name && spendingType && (dailyBudgetSelected || totalBudgetSelected)
    },
  },
  watch: {
    'campaignModel.dailyBudget': {
      handler() {
        if (this.campaignModel.dailyBudget < 0) {
          this.campaignModel.dailyBudget = 0
        }
      },
      deep: true,
    },
    'campaignModel.totalBudget': {
      handler() {
        if (this.campaignModel.totalBudget < 0) {
          this.campaignModel.totalBudget = 0
        }
      },
      deep: true,
    },
    $route: 'fetchData',
  },
  async mounted() {
    await this.fetchData()
  },
  methods: {
    async fetchData() {
      const campaignId = this.id !== undefined ? this.id : 0
      this.campaignModel = await CampaignService.get(campaignId, this.$route.params.accountId)
      this.checkBudgets()
    },
    dailyBudgetChanged() {
      this.campaignModel.budgetType = dailyBudgetType
      this.checkBudgets()
    },
    totalBudgetChanged() {
      this.campaignModel.budgetType = totalBudgetType
      this.checkBudgets()
    },
    checkBudgets() {
      if (
        this.campaignModel.spendingType === 1
        && this.campaignModel.hasEndDate
      ) {
        if (this.campaignModel.budgetType === dailyBudgetType) {
          const startDate = moment(
            new Date(this.campaignModel.startDate),
            'DD/MM/YYYY',
          )
          const endDate = moment(
            new Date(this.campaignModel.endDate),
            'DD/MM/YYYY',
          )
          const days = endDate.diff(startDate, 'days')
          if (this.campaignModel.dailyBudget >= 0) {
            const totalBudget = this.campaignModel.dailyBudget * days
            this.campaignModel.totalBudget = Math.round(totalBudget * 100) / 100
          } else {
            const dailyBudget = this.campaignModel.totalBudget / days
            this.campaignModel.dailyBudget = Math.round(dailyBudget * 100) / 100
          }
        } else {
          const startDate = moment(
            new Date(this.campaignModel.startDate),
            'DD/MM/YYYY',
          )
          const endDate = moment(
            new Date(this.campaignModel.endDate),
            'DD/MM/YYYY',
          )
          const days = endDate.diff(startDate, 'days')
          const dailyBudget = this.campaignModel.totalBudget / days
          this.campaignModel.dailyBudget = Math.round(dailyBudget * 100) / 100
        }
      }
    },
    async saveCampaign() {
      this.saving = true
      this.formatStartEndDates()
      try {
        const response = await CampaignService.createCampaign(
          this.campaignModel,
          this.$route.params.accountId,
        )
        if (response.saved) {
          this.success(response.message)
          if (this.campaignModel.isEdit) {
            if (this.entity) {
              this.editCampaignEntity(this.entity, this.campaignModel, response)
            } else {
              this.$router.push(`/${this.$route.params.accountId}`)
            }
          } else {
            this.$router.push(`/${this.$route.params.accountId}/adgroup/create?campaignId=${response.id}`)
          }
        } else {
          this.errors = response.errors
        }
      } catch (error) {
        this.errors = error.response.errors
        this.error(error.message)
      }
      scrollToError(this.errors)
      this.saving = false
    },
    editCampaignEntity(entity, campaign, response) {
      entity.name = campaign.name
      entity.totalBudget = campaign.totalBudget
      entity.dailyBudget = campaign.dailyBudget
      entity.startDate = this.customFormatter(campaign.startDate)
      for (let i = 0; i < entity.children.length; i += 1) {
        entity.children[i].startDate = entity.startDate
        if (campaign.endDate != null) { entity.children[i].endDate = entity.endDate }

        for (let j = 0; j < entity.children[i].children.length; j += 1) {
          entity.children[i].children[j].startDate = entity.startDate
          if (campaign.endDate != null) { entity.children[i].children[j].endDate = entity.endDate }
        }
      }

      entity.statusId = response.statusId
      entity.status = response.status
      this.closeEditModal()
    },

    cancelCampaign() {
      this.$router.push(`/${this.$route.params.accountId}`)
    },
    customFormatter(date) {
      return moment(date).format('DD/MM/YYYY')
    },
    formatStartEndDates() {
      this.campaignModel.startDate = moment(
        this.campaignModel.startDate,
      ).format('YYYY-MM-DD HH:mm:ss')
      if (this.campaignModel.endDate != null) {
        this.campaignModel.endDate = moment(this.campaignModel.endDate).format()
      }
    },
    showConfirmationModal() {
      this.$refs['navigation-modal'].show()
      return new Promise(resolve => {
        this.$once('confirmed', () => {
          resolve()
        })
      })
    },
    confirm() {
      this.$emit('confirmed')
    },
  },
  beforeRouteLeave(to, from, next) {
    const handlers = this.campaignModel.name
        || this.campaignModel.spendingType === 2
        || this.campaignModel.hasEndDate
        || this.campaignModel.hasTargetGoal
        || this.campaignModel.totalBudgetSelected
        || !this.campaignModel.dailyBudgetSelected
    if (handlers && !this.saving) {
      this.showConfirmationModal().then(() => {
        next()
      }).catch(() => {
        next(false)
      })
    } else {
      next()
    }
  },
}
</script>
